module.exports = __webpack_public_path__ + "static/media/amz_FRONT_VIEW_05.8621f8cd.svg";